import React from "react";
import PropTypes from "prop-types";
import { GridColumn, Button } from "arv-reactcomponents";

const NeftBlock = props => {
  const { neft, isButton, isSelected, selectNeft } = props;
  if (isButton) {
    return (
      <GridColumn className="nwc-grid-col-sm-6 nw-neftblock-column">
        <Button
          className={`nw-neftblock-btn ${
            isSelected ? "nw-neftblock-selected" : ""
          }`}
          onClick={e => selectNeft(e, neft.id)}
        >
          <p>
            Name:
            {neft.customerName}
          </p>
          <p>
            Account No:
            {neft.accountNumber}
          </p>
          <p>
            IFSC Code:
            {neft.ifscCode}
          </p>
          <p>
            Bank Name:
            {neft.bankName}
          </p>
          <p>
            Branch Name:
            {neft.branchName}
          </p>
          <p>
            Acc Nature:
            {neft.accountNature}
          </p>
        </Button>
      </GridColumn>
    );
  }
  return (
    <GridColumn className="nwc-grid-col-sm-6 nw-neftblock-column">
      <p>
        Name:
        {neft.customerName}
      </p>
      <p>
        Account No:
        {neft.accountNumber}
      </p>
      <p>
        IFSC Code:
        {neft.ifscCode}
      </p>
      <p>
        Bank Name:
        {neft.bankName}
      </p>
      <p>
        Branch Name:
        {neft.branchAddress}
      </p>
      <p>
        Acc Nature:
        {neft.accountNature}
      </p>
    </GridColumn>
  );
};

NeftBlock.defaultProps = {
  isButton: false,
  isSelected: false,
  selectNeft: PropTypes.func,
};

NeftBlock.propTypes = {
  neft: PropTypes.shape({}).isRequired,
  isButton: PropTypes.bool,
  isSelected: PropTypes.bool,
  selectNeft: PropTypes.func,
};

const getFinalComponent = component => component;

const ProjectComponent = {
  getFinalComponent,
  wrapper: NeftBlock,
  component: NeftBlock,
};

export default ProjectComponent;
